import type { RentalPriceTiers, Vehicle } from "@/data/vehicles";

export type RentalDurationTierKey = keyof RentalPriceTiers;

export const RENTAL_DURATION_LABELS: Record<RentalDurationTierKey, string> = {
  oneToThreeDays: "1 a 3 jours",
  fourToSixDays: "4 a 6 jours",
  sevenPlusDays: "7 jours et +",
};

export const RENTAL_DURATION_OPTIONS: Array<{
  value: RentalDurationTierKey;
  label: string;
}> = [
  { value: "oneToThreeDays", label: RENTAL_DURATION_LABELS.oneToThreeDays },
  { value: "fourToSixDays", label: RENTAL_DURATION_LABELS.fourToSixDays },
  { value: "sevenPlusDays", label: RENTAL_DURATION_LABELS.sevenPlusDays },
];

export const formatEuro = (amount: number) =>
  `${amount.toLocaleString("fr-FR")} \u20AC`;

const buildFlatTiers = (amount: number): RentalPriceTiers => ({
  oneToThreeDays: amount,
  fourToSixDays: amount,
  sevenPlusDays: amount,
});

export const getRentalPriceTiers = (
  vehicle: Vehicle | null | undefined,
): RentalPriceTiers | null => {
  if (!vehicle || vehicle.price.type !== "per_day") return null;
  return vehicle.price.tiers ?? buildFlatTiers(vehicle.price.amount);
};
